import type { OrbState } from 'thinking-orbs';
import type { BotState } from './motionSystem';

const TOOL_ACTIVITIES: Record<string, OrbState> = {
    search_articles: 'searching',
    read_article: 'weaving',
    get_profile: 'searching',
    chart: 'shaping',
    navigate: 'connecting',
    set_theme: 'shaping',
    get_browser_context: 'searching',
    get_location: 'searching',
    get_weather: 'connecting',
    get_network_info: 'searching',
    get_screen_info: 'searching',
    get_clipboard: 'searching',
};

export function toolActivity(tool?: string): OrbState {
    return tool ? TOOL_ACTIVITIES[tool] ?? 'working' : 'working';
}

export function agentActivity(state: BotState, work: OrbState = 'working'): OrbState | null {
    switch (state) {
        case 'curious': return 'listening';
        case 'thinking': return 'solving';
        case 'working': return work;
        case 'waiting': return 'breathing';
        default: return null;
    }
}
